import { render, staticRenderFns } from "./GalleryHeader.vue?vue&type=template&id=7e2016be&"
import script from "./GalleryHeader.vue?vue&type=script&lang=js&"
export * from "./GalleryHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports